<template lang="pug">
include ../../../prototype/src/pug/abstracts/variables
include ../../../prototype/src/pug/abstracts/mixin.pug
.banner_comprar_agora__wrapper
	.banner_comprar_agora__inner
		.banner_comprar_agora__content
			h1 Compre seu Certificado Digital com o SPC Brasil
			p Suas transações digitais com segurança real.
			a(:href="url").button.button--white Comprar agora

		.banner_comprar_agora__image
			+i('illustration_banner_comprar_agora.svg')
</template>

<script>
export default {
	name: "BannerComprarAgora",
	props: ["url"],
};
</script>
